import menu from "../layouts/main-layout.vue";
import index from "../pages/painel.vue";
import login from "../pages/sign-in.vue";
import config from "../pages/config.vue";
import paineis from "../pages/listagem-paineis.vue";
var routes = [{
  path: "/",
  component: login,
  props: true
}, {
  path: "/:cliente",
  component: login,
  props: true
}, {
  path: "/",
  component: menu,
  children: [{
    path: "/:cliente/config",
    props: true,
    component: config
  }, {
    path: "/:cliente/config/manage/api",
    component: config
  }, {
    path: "/:cliente/painel/:channel/pre-ativado",
    props: true,
    component: index
  }, {
    path: "/:cliente/painel/:channel",
    props: true,
    component: index
  }, {
    path: "/:cliente/paineis",
    props: true,
    component: paineis
  }, {
    path: "/:cliente/paineis/:painel",
    props: true,
    component: config
  }]
}];

// Always leave this as last one
if (process.env.MODE !== "ssr") {
  routes.push({
    path: "*",
    component: function component() {
      return import("../pages/error404.vue");
    }
  });
}
export default routes;